export function getAuthStateCode() {
  // OAuth CSRF state — must be unguessable, so use the CSPRNG.
  // getRandomValues() works in insecure contexts too (randomUUID does not).
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}
